var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInstallationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.00390625,
    width: 60,
    height: 60,
    rx: 4,
    fill: "#8097AC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.3401 38.6594C22.0546 39.3771 22.86 39.3211 23.5874 38.4992L31.4157 29.638L29.0582 27.2733L20.168 35.0797C19.3317 35.8039 19.2861 36.6094 20.0006 37.3199L21.3401 38.6594ZM35.8165 31.7029C36.1366 32.0158 36.4966 32.0342 36.816 31.7252L39.2826 29.2657C39.5877 28.9679 39.566 28.5759 39.2532 28.2662L38.6439 27.6675C38.3167 27.3331 38.1181 27.2907 37.745 27.3155L36.8762 27.4122L36.2161 26.7592L36.4866 25.6517C36.6123 25.0885 36.4219 24.5363 35.8503 23.9751L34.1773 22.3053C31.9179 20.0667 27.8123 19.8192 25.5223 22.102C25.1444 22.4728 25.209 22.8996 25.4404 23.1614C25.6301 23.3464 25.9168 23.4434 26.2084 23.3586C27.7814 22.9257 29.1579 22.8531 30.3519 23.6038L29.7172 25.217C29.4521 25.8751 29.5922 26.3533 30.0286 26.7858L31.8591 28.6267C32.1842 28.9518 32.5108 29.0366 33.0209 28.9317L34.2983 28.6802L34.9408 29.3299L34.869 30.1947C34.8442 30.583 34.8729 30.7913 35.2073 31.1185L35.8165 31.7029Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstallationIcon);
export default __webpack_public_path__ + "static/media/installation-icon.1a4f68194ff8ce29fcd9559ebaf64b11.svg";
export { ForwardRef as ReactComponent };